import axios from "axios";
import { prerelease } from "platform";
import React, { useContext } from "react";
import { useCookies } from "react-cookie";
import { IoClose } from "react-icons/io5";
import globalContext from "../../Contexts/GlobalContext";
import { SERVERMODE } from "../../constants/serverMode";
import { handleServerMode } from "../../utils/handleServer";
import { useNavigate } from "react-router-dom";
import { SERVERMESSAGE } from "../../constants/serverMessage";
import useRequestHeader from "../../hooks/useRequestHeader";

export default function ServicePlaceCancel({
  setIsCancelServicePlaceOpen,
  cancelRefId,
  cancelType,
  setIsCancelLoading,
  setUpdatehistoryListFlag,
}) {
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  const navigate = useNavigate();
  const requestHeader = useRequestHeader();
  const contextData = useContext(globalContext);
  const [cookies, setCookies, removeCookies] = useCookies();
  const cancelService = () => {
    setIsCancelLoading(true);
    setIsCancelServicePlaceOpen(false);
    const config = {
      headers: requestHeader,
    };
    axios
      .post(
        `${BASE_URL}/service/place/cancel/users`,
        {
          plate: cookies?.plate,
          reference: cancelRefId,
        },
        config
      )
      .then((res) => {
        var responseMode = res?.data?.Mode;
        var responseMessage = res?.data?.Message;
        switch (responseMode) {
          case SERVERMODE.REQUEST_OK: {
            setUpdatehistoryListFlag((prev) => !prev);
            contextData.setIsToastOpen(true);
            contextData.setToastMessage(
              SERVERMESSAGE.SUCCESS_CANCEL_SERVICE_PLACE
            );
            break;
          }
          default: {
            handleServerMode(
              responseMode,
              responseMessage,
              contextData,
              cookies,
              removeCookies,
              navigate
            );
          }
        }
        setIsCancelLoading(false);
      })
      .catch((err) => {
        setIsCancelLoading(false);
        contextData.setIsToastOpen(true);
        contextData.setToastMessage("ارتباط با سرور دچار مشکل شده است");
      });
  };
  return (
    <div className="absolute w-full h-screen backdrop-blur-sm flex items-center justify-center z-[1000] ">
      <div
        className={`relative w-[80vw] pb-[3vw] bg-[#001D26] border-color-primary-D   flex flex-col items-center justify-evenly border-[1px] z-[800] rounded-[1vw]  `}
      >
        <div className="w-full flex items-center justify-center bg-color-primary-D font-font_primary_A text-[#153038]">
          <span className="py-[2vw] font-bold">لغو سرویس</span>
        </div>

        <span
          className={`w-full text-center flex items-center justify-start text-[3vw] z-[800] text-color-primary-C font-font_primary_A mt-[3.7vw] px-[4vw]`}
        >
          آیا می‌خواهید سرویس {cancelType} خود را لغو نمایید
        </span>

        <div className="flex items-center justify-between gap-x-[3vw] mt-[3.7vw]">
          <button
            className="relative w-[30vw] h-[9vw]  rounded-[1vw] text-center flex items-center justify-center text-[#AF3434] font-font_primary_A text-[4vw] bg-[#001D26] z-[1000]"
            onClick={() => {
              setIsCancelServicePlaceOpen(false);
            }}
          >
            خیر
          </button>
          <button
            className="relative w-[30vw] h-[9vw] rounded-[1vw] text-center flex items-center justify-center text-[#F8F8F3] font-font_primary_A text-[4vw] bg-[#153038] z-[1000]"
            onClick={cancelService}
          >
            بله
          </button>
        </div>
      </div>
    </div>
  );
}
